/** Generated by @jobilla/openapi-codegen. Do not edit manually. */

import { z } from 'zod/v4'

export const listCandidateEventsResponseSchema = z.object({
	events: z.array(
		z.object({
			id: z.string(),
			type: z.union([
				z.literal('invitation_created'),
				z.literal('invitation_sent'),
				z.literal('invitation_superseded'),
				z.literal('invitation_expired'),
				z.literal('booking_confirmed'),
				z.literal('booking_cancelled'),
				z.literal('stage_changed'),
				z.literal('email_sent'),
				z.literal('email_received'),
				z.literal('whatsapp_sent'),
				z.literal('whatsapp_received'),
				z.literal('applied'),
			]),
			actorType: z.union([z.literal('recruiter'), z.literal('candidate'), z.literal('system')]),
			actorId: z.string().nullable(),
			occurredAt: z.iso.datetime(),
			context: z.record(z.string(), z.unknown()),
			booking: z.object({
				id: z.string(),
				status: z.union([z.literal('confirmed'), z.literal('cancelled')]),
				candidateAttended: z.boolean().nullable(),
				meeting: z.object({
					type: z.union([
						z.literal('jobilla_meet'),
						z.literal('google_meet'),
						z.literal('teams'),
						z.literal('zoom'),
						z.literal('phone'),
						z.literal('in_person'),
						z.literal('custom'),
					]),
					startsAt: z.iso.datetime(),
					endsAt: z.iso.datetime(),
					joinableAt: z.iso.datetime(),
					expiresAt: z.iso.datetime(),
					duration: z.number(),
					locationDetails: z.string().nullable(),
					candidateLink: z.string().nullable(),
					recruiterLink: z.string().nullable(),
				}),
			}).nullable(),
		}),
	),
})

export type ListCandidateEventsResponseSchema = z.infer<typeof listCandidateEventsResponseSchema>
